import { Options } from 'lib/api/folderAccess/types';

export type Option = {
  value: string;
  label: string;
};

export type LabelOption = {
  value: string;
  label: React.JSX.Element;
};

export interface MatchParams {
  folderId: string;
  page?: string;
}

export type FilterProps = {
  marginRight?: number;
  width?: number | string;
};

export interface FolderAccessSettings {
  id?: number;
  folderId?: number;
  access?: string;
  targetType?: TargetType | undefined;
  targetId?: string | number | undefined;
  isDeleted?: boolean;
  targetName?: string;
  name?: string;
  email?: string;
  isReadOnly?: boolean;
  options?: Options[];
  children?: Options[];
  targetCustomerId?: number;
  targetCustomerName?: string;
  targetUserId?: number;
  targetUserName?: string;
  targetResellerId?: number;
  targetResellerName?: string;
  targetOrganizationId?: number;
  targetOrganizationName?: string;
  targetRegionId?: number;
  targetRegionName?: string;
  targetDepartmentId?: number;
  targetDepartmentName?: string;
  targetAutomotiveRoleId?: number;
  targetAutomotiveRoleName?: string;
  targetUserAccess?: number;
  targetUserAccessName?: string;
}

export enum TargetType {
  ACCESS = 'access',
  ROLE = 'role',
  DEPARTMENT = 'department',
  CUSTOMER = 'customer',
  RESELLER = 'reseller',
  USER = 'user',
  ORGANIZATION = 'organization',
  REGION = 'region',
}

export enum FOLDER_SHARED_AS {
  COMPANY_ADMIN = 'company_admin',
  OEM_ADMIN = 'oem_admin',
}

export type RowData = {
  access: string;
  targetOrganizationId?: number;
  targetOrganizationName?: string;
  targetRegionId?: number;
  targetRegionName?: string;
  targetCustomerId?: number;
  targetCustomerName?: string;
};

export type OemCardItem = {
  id: number;
  name: string;
  isReadOnly: boolean;
  isDeleted: boolean;
  rowData: RowData[];
};
